import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../contexts/UserContext";

import { useMutation } from "@apollo/client";
import { useQuery } from "@apollo/client";
import { GET_OBJECTIVES_BY_USER_ID } from "../../apollo-queries";
import { UPDATE_OBJECTIVES_BY_USER_ID } from "../../apollo-mutations";

import { ObjectiveText, NavigationText } from "../../Text";
import { CiCircleInfo } from "react-icons/ci";
import Tooltip from "@mui/material/Tooltip";
import { Button } from "@mui/base";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";

const ObjectiveForm: React.FC = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  const {
    loading: objectiveLoading,
    error: objectiveError,
    data: databaseData,
  } = useQuery(GET_OBJECTIVES_BY_USER_ID, {
    variables: { user_id: user.uuid },
    fetchPolicy: "network-only", // stops apollo from getting data from the cache and instead queries the DB
  });

  const [UpdateObjectivesByUserId, { loading, error }] = useMutation(
    UPDATE_OBJECTIVES_BY_USER_ID
  );
  // track the form data
  const { register, watch, setValue } = useForm({
    defaultValues:
      databaseData !== undefined
        ? databaseData?.objectives[0]
        : {
            description: "",
          },
  });

  // update the form data when the database data changes
  useEffect(() => {
    if (databaseData?.objectives[0]?.description) {
      setValue("description", databaseData?.objectives[0]?.description);
    } else {
      setValue("description", "");
    }
  }, [databaseData]);

  // update the database data when the form data changes
  useEffect(() => {
    return () => {
      const updatedFormData = watch();
      UpdateObjectivesByUserId({
        variables: {
          user_id: user.uuid,
          description: updatedFormData.description,
        },
      })
        .then((response) => {
          console.log("Objective created:", response.data.createObjective);
        })
        .catch((error) => {
          console.error("Error creating objective:", error);
        });
    };
  }, []); 

  const handleNext = () => {
    navigate(`/Costs/${user.uuid}`);
  };

  const handlePrevious = () => {
    navigate(`/Instructions/${user.uuid}`);
  };

  return (
    <>
      <form className="w-full mt-6 p-6 flex flex-col space-y-4 rounded-md bg-white drop-shadow-lg">
        {/* Description Form */}
        <div className="flex items-center">
          <label className="font-semibold text-xl">
            {ObjectiveText.objective.label}
          </label>
          <Tooltip
            title={
              <>
                <h3 className="font-bold">{ObjectiveText.objective.label}</h3>
                <div>{ObjectiveText.objective.tooltip}</div>
              </>
            }
            placement="right"
            arrow
          >
            <Button>
              <CiCircleInfo className="mx-2 self-center" />
            </Button>
          </Tooltip>
        </div>
        <textarea
          {...register("description")}
          className="w-full h-20 p-2 border border-light-gray rounded-md"
        />
      </form>
      {/* Navigation Buttons */}
      <div className="mt-4 mb-20 flex justify-between text-UDig-orange">
        <Button
          className="flex items-center gap-x-2"
          type="button"
          onClick={() => {
            handlePrevious();
          }}
        >
          <BsArrowLeft />
          {NavigationText.previous}
        </Button>
        <Button
          className="flex items-center gap-x-2"
          type="button"
          onClick={() => handleNext()}
        >
          {NavigationText.next}
          <BsArrowRight />
        </Button>
      </div>
    </>
  );
};

export default ObjectiveForm;
